
/**
 * Judge Rubrics Tab Help Content
 */
const JudgeRubricsHelp = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Judge Rubrics
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Judge Rubrics define evaluation criteria for LLM-as-Judge scoring. Create custom rubrics to assess agent outputs based on your specific quality standards.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          What is a Rubric?
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          A rubric is a scoring guide that tells the judge LLM how to evaluate outputs:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Criteria</span>: What aspects to evaluate (accuracy, tone, completeness)</p>
          <p>&#8226; <span className="font-medium">Score Range</span>: Numerical scale (e.g., 1-5, 0-100)</p>
          <p>&#8226; <span className="font-medium">Guidelines</span>: Detailed scoring instructions</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Creating a Rubric
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>1. Click "Create Rubric"</p>
          <p>2. Name your rubric (e.g., "Code Review Quality")</p>
          <p>3. Define evaluation criteria</p>
          <p>4. Set scoring scale and thresholds</p>
          <p>5. Add example good/bad outputs (optional)</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Built-in Rubrics
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Pre-configured rubrics for common use cases:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Accuracy</span>: Factual correctness</p>
          <p>&#8226; <span className="font-medium">Helpfulness</span>: User value and actionability</p>
          <p>&#8226; <span className="font-medium">Safety</span>: Harmful content detection</p>
          <p>&#8226; <span className="font-medium">Coherence</span>: Logical flow and clarity</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Using Rubrics in Evaluations
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          When running evaluations, select a rubric to apply consistent scoring criteria. The judge LLM will use your rubric guidelines to score each test case.
        </p>
      </div>

      <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
        <p className="text-xs text-gray-500 dark:text-gray-500">
          Configure <span className="font-medium">LLM Providers</span> to enable judge functionality.
        </p>
      </div>
    </>
  );
};

export default JudgeRubricsHelp;
